import { z } from "zod";

/**
 * Dosya politikası (ADR-0010 D7, CLOS-311).
 *
 * İzin verilen tipler ve azami boyut ŞEMADA tanımlıdır; sunucu presign anında doğrular.
 * İstemci doğrulaması yalnız kullanıcı deneyimidir, güvenlik sınırı değildir.
 */

/**
 * Sözleşme platformunun kabul ettiği belge tipleri. Liste dar tutulur: her yeni tip
 * yeni bir ayrıştırıcı yüzeyi ve yeni bir zararlı içerik vektörüdür.
 */
export const ALLOWED_CONTENT_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/msword", // .doc
  "image/png",
  "image/jpeg",
] as const;

/** 25 MiB — sözleşme ve ekleri için bol; tek istekte belleği tüketmeyecek kadar dar. */
export const MAX_FILE_BYTES = 25 * 1024 * 1024;

/**
 * Dosya adı kullanıcıya gösterilir, depolama yolunu ETKİLEMEZ (yol geçişi yüzeyi
 * değildir). Yine de sınırlanır: kontrol karakteri ve yol ayıracı taşıyan bir ad,
 * indirme başlığında ve arayüzde sorun çıkarır.
 */
export const fileNameSchema = z
  .string()
  .min(1, "Dosya adı zorunludur")
  .max(255, "Dosya adı en fazla 255 karakter olabilir")
  .refine((v) => !/[/\\]/.test(v), "Dosya adı yol ayıracı içeremez")
  // eslint-disable-next-line no-control-regex
  .refine((v) => !/[\u0000-\u001f]/.test(v), "Dosya adı geçersiz karakter içeriyor");

export const uploadUrlRequestSchema = z.object({
  domain: z.string().regex(/^[a-z][a-z0-9-]{0,63}$/, "Geçersiz alan adı"),
  entityId: z.uuid("Geçerli bir kayıt kimliği değil"),
  fileName: fileNameSchema,
  contentType: z.enum(ALLOWED_CONTENT_TYPES, "Bu dosya türü desteklenmiyor"),
  sizeBytes: z
    .number()
    .int("Dosya boyutu tam sayı olmalıdır")
    .positive("Dosya boyutu sıfırdan büyük olmalıdır")
    .max(MAX_FILE_BYTES, "Dosya en fazla 25 MB olabilir"),
});
export type UploadUrlRequest = z.infer<typeof uploadUrlRequestSchema>;

/**
 * Yükleme bileti — sunucunun verdiği izin.
 *
 * ⚠ Tip PAYLAŞILAN pakette: aynı sözleşmeyi hem API hem tarayıcı okuyor ve ikisi
 * birbirinden import edemiyor (ADR-0008 M5). İki yerde ayrı yazılsaydı, alan adı
 * değiştiğinde biri sessizce geride kalırdı.
 */
export type UploadTicket = {
  objectId: string;
  uploadUrl: string;
  expiresInSeconds: number;
};

/**
 * Yükleme tamamlandı bildirimi. İstemci checksum GÖNDERMEZ — gönderseydi, kendi
 * yüklediği dosyanın özetini kendisi beyan ederdi ve bütünlük kontrolü anlamını
 * yitirirdi. Sunucu nesneyi okuyup kendisi hesaplar.
 */
export const completeUploadRequestSchema = z.object({});
export type CompleteUploadRequest = z.infer<typeof completeUploadRequestSchema>;
